/* eslint-disable @typescript-eslint/no-explicit-any */
export const ProfileKeys = {
  allProfiles: ['Profiles'] as const,
  listProfiles: () => [...ProfileKeys.allProfiles, 'listProfiles'] as const,
  listProfile: (params: any) => [...ProfileKeys.listProfiles(), { params }] as const,
}
